import React, { useEffect } from 'react';
import { Alert, Button, Card, Flex, Space } from 'antd';
import DetalhesOperacao from './DetalhesOperacao';
import STATUS from '../Constants/status';
import BotaoCancelamento from './BotaoCancelamento';
import { Link } from 'react-router-dom';
import '../styles.css';

function OperacaoEmAndamento({ ultimoLog, obterUltimoLog, cancelarOperacao }) {
    const intervaloEmSegundos = 30;

    useEffect(() => {
        const intervalo = configurarIntervaloAtualizacao();
        return () => clearInterval(intervalo);
    }, [obterUltimoLog]);

    const configurarIntervaloAtualizacao = () => {
        return setInterval(() => {
            obterUltimoLog();
        }, intervaloEmSegundos * 1000);
    }

    const obterMensagem = () => {
        if (ultimoLog.statusOperacao === STATUS.EM_VALIDACAO) {
            return 'Estamos validando os usuários do arquivo enviado para garantir uma criação segura e sem erros.';
        }
        if (ultimoLog.statusOperacao === STATUS.EM_PROCESSAMENTO) {
            return 'Estamos processando a criação dos usuários.';
        }
        if (ultimoLog.statusOperacao === STATUS.EM_CANCELAMENTO) {
            return 'Aguarde o cancelamento da operação para solicitar uma nova.';
        }
        return 'Último arquivo ainda está sendo trabalhado.';
    }

    const descricao = (
        <Flex vertical>
            {ultimoLog.statusOperacao === STATUS.EM_VALIDACAO && (
                <span>Você receberá um e-mail com o resultado da validação.</span>
            )}
            {ultimoLog.statusOperacao === STATUS.EM_PROCESSAMENTO && (
                <span>Você receberá um e-mail para cada usuário criado, informando o sucesso da operação.</span>
            )}
            {ultimoLog.statusOperacao !== STATUS.EM_PROCESSAMENTO &&
             ultimoLog.statusOperacao !== STATUS.EM_CANCELAMENTO && (
                <span>A operação pode ser cancelada, exceto quando o status estiver como "Em processamento".</span>
            )}
            <span>O status será atualizado a cada {intervaloEmSegundos} segundos.</span>
        </Flex>
    );

    return (
        <Card title="Status do processamento">
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <DetalhesOperacao ultimoLog={ultimoLog} />

                <Alert
                    style={{ marginTop: 16 }}
                    message={<strong>{obterMensagem()}</strong>}
                    description = {descricao}
                    type="info"
                    showIcon
                />

                <Flex justify="end" gap="small" className='flex-botoes-progresso'>
                    <Link to="/usuarios">
                        <Button>Sair</Button>
                    </Link>
                    {ultimoLog.statusOperacao !== STATUS.EM_PROCESSAMENTO && (
                        <BotaoCancelamento
                            cancelarOperacao={cancelarOperacao}
                        />
                    )}
                </Flex>
            </Space>
        </Card>
    );
}

export default OperacaoEmAndamento;